/*
 * @Author: Yun
 * @Date: 2023-12-13 14:22:38
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-29 16:58:39
 */
let files = [
    {
        type: 'IMAGE',
        source: require('@icons/cgtn.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/first.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/first_2.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/first_.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/second.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/greetings.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/fourth.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/photowall.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/m-first.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/m-first_2.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/m-first.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/m-second.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/m-greetings.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/m-fourth.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/firstPage/title.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/firstPage/m-title.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/greetings/videocover.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/fourthPage/title.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/fourthPage/m-title.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img1.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img2.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img3.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img4.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img5.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img6.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img7.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img8.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img9.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img10.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img11.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img12.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img13.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/timelines/img14.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/all.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img1.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img2.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img3.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img4.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img5.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img6.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img7.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img8.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img9.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img10.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img11.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img12.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img13.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/img14.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/dataviz/m-region.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/diplomacy/data.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/diplomacy/first.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/diplomacy/m-first.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/diplomacy/m-title.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/diplomacy/second.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/diplomacy/title.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img1.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img2.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img3.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img4.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img5.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img6.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img7.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img8.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img9.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img10.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img11.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img12.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img13.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img14.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img15.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img16.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img17.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img18.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img19.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img20.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/img21.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/photowall/photos.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/more/first.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/more/second.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/more/third.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/olds/16.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/olds/17.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/olds/18.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/olds/19.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/olds/20.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/olds/21.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/olds/22.png'),
        size: 100,
    },

    {
        type: 'IMAGE',
        source: require('@images/footer/dy.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/fb.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/ins.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/logo.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/mp.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/pint.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/qr-wechat.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/tum.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/wb.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/wechat.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/x.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/yt.png'),
        size: 100,
    },
]

export { files }
